<template>
  <Layout>
    <div class="mc-report__delivery-history">
      <PageHeader :title="title">
        <template #afterTitle>
          <div class="d-flex align-items-center gap-2">
            <McListDownloader
              :pageOptions="downloadPageOptions"
              :fileFormatOptions="['excel']"
              @download="handleDownload"
            />
            <McButtonBack />
          </div>
        </template>
      </PageHeader>
      <McTable
        withCard
        searchable
        :fields.sync="computedFields"
        :apiClient="apiClient"
        :hasCheckbox="false"
        hasViewManager
      >
        <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
          <TableViewManager
            :defaultColumnOrder="initialFields"
            :currentColumnOrder="dataFields"
            @setColumn="handleSetDataFields"
          />
        </template>
        <template #cell()="{ field, value }">
          {{ formatValues(field.key, value) }}
        </template>
      </McTable>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'

import Layout from '@/router/layouts/main'
import PageHeader from '@/components/page-header-v2.vue'
import McButtonBack from '@/components/McButtonBack'
import McTable from '@/components/McTable'
import McListDownloader from '@/components/McListDownloader'
import TableViewManager from '../components/TableViewManager'

import * as Report from '@/services/rest-api/lib/report/report.js'

import fields from './lib/fields/fields'
import { formatValues } from './lib/helpers/formatValues'
import omitBy from 'lodash/omitBy'

export default {
  page: {
    title: 'Report Delivery History',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButtonBack,
    McTable,
    McListDownloader,
    TableViewManager,
  },
  mixins: [fields],
  data() {
    return {
      params: {},
      metadata: null,
    }
  },
  computed: {
    title() {
      return 'Riwayat Pengiriman'
    },
    apiClient() {
      return {
        get: Report.getReportDeliveryHistory(this.handleSetParams, this.handleSetMetadata),
      }
    },
    computedFields() {
      const computedFields = []

      this.fields.forEach(field => {
        if (!field.isShow) return

        computedFields.push(field)
      })
      return computedFields
    },
    downloadPageOptions() {
      return [
        { label: this.$t('global.currentPage'), amount: this.metadata?.count, key: 'current_page' },
        { label: this.$t('global.allPages'), amount: this.metadata?.total_count, key: 'all' },
      ]
    },
  },
  methods: {
    formatValues,
    handleDownload(format, dataAmount) {
      // Remove undefined params
      const params = omitBy(
        {
          ...this.params,
          format,
        },
        (value) => value === undefined
      )

      if (dataAmount === 'all') {
        delete params['limit']
        delete params['page']
      }

      window.open(
        `${process.env.VUE_APP_API_ORDER_URL}/report/1?${new URLSearchParams(params).toString()}`,
        '_self'
      )
    },
    handleSetParams(params) {
      this.params = params
    },
    handleSetMetadata(metadata) {
      this.metadata = metadata
    },
  },
}
</script>
